import React from "react";
import { useDispatch } from "react-redux";
import { Field, Form, Formik } from "formik";
import * as i18nUtils from "util/i18n";
import { actions as adheredServicesActions } from "reducers/afipPaymentLink";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { Col, Row } from "react-bootstrap";
import Container from "pages/_components/Container";

const FORM_ID = "linkedservice.remove";

const RemoveService = ({ service, setDrawer }) => {
    const dispatch = useDispatch();
    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
        },
        onSubmit: (values) => {
            if (values) {
                dispatch(adheredServicesActions.deleteAdheredService(service.adhesionCode));
                setDrawer({
                    showDrawer: false,
                    contentDrawer: null,
                });
                
            }
        },
    };

    return (
        <div className="container">
        <h2 className="title-content text-center">
            <I18n id={`${FORM_ID}.drawertitle`} />
        </h2>
        <div className="row">
         <Formik {...formikProps}>
        {() => (
            <Form className="above-the-fold">
                <Container className="container--layout flex-grow">
                    <Row className="gap-8">
                        <Col sm={12} md={8} mdOffset={2} className="form-group form-group--select">
                            <Field
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="id"
                                labelTextDefault={i18nUtils.get(`${FORM_ID}.service`)}
                                hidePlaceholder
                                disabled
                                value={service.entityName}
                            />
                        </Col>

                        <Col sm={12} md={8} mdOffset={2}>
                        <Field
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="alias"
                                labelTextDefault={i18nUtils.get(`${FORM_ID}.alias`)}
                                hidePlaceholder
                                disabled
                                value={service.alias ? service.alias : "-"}
                            />
                        </Col>

                        <Col sm={12} md={8} mdOffset={2}>
                            <Field
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="paymentCode"
                                labelTextDefault={i18nUtils.get(`${FORM_ID}.paymentCode`)}
                                hidePlaceholder
                                disabled
                                value={service.codeLink}
                            />
                        </Col>

                        <Col sm={12} md={8} mdOffset={2}>
                            <Button type="submit" bsStyle="primary" label="global.delete" loading={false} block />
                        </Col>
                    </Row>
                </Container>
            </Form>
             )}
        </Formik>
        </div>
    </div>
    );
};

RemoveService.propTypes = {
};

RemoveService.defaultProps = {};

export default RemoveService;
